import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const getResubmissionList = (id) => {
  return api
    .get(`${API_URL}resubmission/${id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getResubmissionListAdmin = () => {
  return api
    .get(`${API_URL}resubmission/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getResubmission = async (rsm_id) => {
  return api.get(API_URL + `resubmission/${rsm_id}`).then((res) =>
  {
    if (res.data) return res.data;
  }).catch((err) => err);
};

export const createResubmission = (data) => {
  return api.post(`${API_URL}resubmission`, data);
};

export const updateResubmission = (rsm_id, status) => {
  return api.put(`${API_URL}resubmission/${rsm_id}/${status}`);
};
